const BLINK_PREFIX = '* '
const VISIBLE_PULSE_MS = 4000
const TOGGLE_MS = 800

let originalTitle: string | null = null
let toggleTimer: ReturnType<typeof setInterval> | null = null
let stopTimer: ReturnType<typeof setTimeout> | null = null
let visibilityHandler: (() => void) | null = null
let prefixed = false

function ensureOriginalTitle(): string {
  if (originalTitle == null) {
    originalTitle = document.title.startsWith(BLINK_PREFIX)
      ? document.title.slice(BLINK_PREFIX.length)
      : document.title
  }
  return originalTitle
}

function restoreTitle(): void {
  if (originalTitle != null) {
    document.title = originalTitle
  }
  originalTitle = null
  prefixed = false
}

function clearTimers(): void {
  if (toggleTimer) {
    clearInterval(toggleTimer)
    toggleTimer = null
  }
  if (stopTimer) {
    clearTimeout(stopTimer)
    stopTimer = null
  }
}

function detachVisibility(): void {
  if (visibilityHandler) {
    document.removeEventListener('visibilitychange', visibilityHandler)
    visibilityHandler = null
  }
}

export function stopDocumentTitleBlink(): void {
  clearTimers()
  detachVisibility()
  restoreTitle()
}

export function startDocumentTitleBlink(): void {
  if (typeof document === 'undefined') return

  stopDocumentTitleBlink()
  ensureOriginalTitle()

  const tick = () => {
    const base = ensureOriginalTitle()
    prefixed = !prefixed
    document.title = prefixed ? `${BLINK_PREFIX}${base}` : base
  }

  tick()
  toggleTimer = setInterval(tick, TOGGLE_MS)

  visibilityHandler = () => {
    if (!document.hidden) {
      stopDocumentTitleBlink()
    }
  }
  document.addEventListener('visibilitychange', visibilityHandler)

  if (!document.hidden) {
    stopTimer = setTimeout(() => {
      stopDocumentTitleBlink()
    }, VISIBLE_PULSE_MS)
  }
}

export function didCounterIncrease(
  previous: number[] | undefined,
  next: number[],
): boolean {
  const prevPrimary = previous?.[0] ?? 0
  const nextPrimary = next[0] ?? 0
  return nextPrimary > prevPrimary
}

export function shouldBlinkForIncreasedItems(
  increasedIds: string[],
  isIgnored: (itemId: string) => boolean,
  hideAll: boolean,
): boolean {
  if (hideAll || increasedIds.length === 0) return false
  return increasedIds.some((id) => !isIgnored(id))
}
